import { render, staticRenderFns } from "./update_org.vue?vue&type=template&id=ab629a1a&"
import script from "./update_org.vue?vue&type=script&lang=js&"
export * from "./update_org.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports